import dog_project from "@shared/assets/webp/builddog.webp";

import "./project-empty.scss";

export const Empty = () => {
  return (
    <main className="no-projects-layout">
      <div className="no-projects-content">
        <img
          src={dog_project as string}
          alt="No Projects"
          className="no-projects-image"
        />
        <h2 className="no-projects-title">Список проектов пуст</h2>
      </div>
    </main>
  );
};
